import React from "react";
import { Container } from "@material-ui/core";
import DirectoryContent from "./directory-content/DirectoryContent";
import { useFileExplorerReducer, setFilterTextAction, setFilterTagsAction, setSelectedFileSystemNodePathAction, setDirectoryContentTargetItemIndexAction } from '../../services/file-explorer/fileExplorerReducer';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Uploader } from "./uploader/Uploader";
import UploaderDashboard from "./uploader/uploader-dashboard/UploaderDashboard";
import FilterTextField from "./search/FilterTextField";
import TagField from "./search/TagField";
import Breadcrumbs from "./breadcrumbs/Breadcrumbs";
import { getResourceByPath } from "../../services/resource/resourceApi";
import { useQuery } from "react-query";
import CenteredSpinner from "../loading/CenteredSpinner";
import MissingResourceAlert from "../resource/MissingResourceAlert";
import Media from "../file/Media";
import DownloadButton from "../file/DownloadButton";
import { useAuthenticated } from "ra-core";

const FileExplorer = () => {
    const [state, dispatch] = useFileExplorerReducer();

    useAuthenticated();

    const slashConcatenatedFileSystemNodePath = state.selectedFileSystemNodePath.join('/');
    const { data, isLoading } = useQuery(['/resource/{path}', 'getResourceByPath', slashConcatenatedFileSystemNodePath], () => getResourceByPath(slashConcatenatedFileSystemNodePath));
    const fileSystemNodeDirectLinkUrl = `/api/resource/download/${state.selectedFileSystemNodePath.join('/')}`;
    const fileSystemNodePreviewDirectLinkUrl = `/api/resource/preview/download/${state.selectedFileSystemNodePath.join('/')}`;
    const fileSystemNodeType = (() => {
        if (data) {
            return data.type;
        }
        if (isLoading) {
            return state.predictedSelectedFileSystemNodeType;
        }
        return null;
    })();
    const fileSystemNodePreviewState = (() => {
        if (data) {
            return data.preview_state;
        }
        if (isLoading) {
            return 'none';
        }
        return null;
    })();

    return (
        <Container maxWidth="xl">
            <Box mt={2} mb={2}>
                <Paper>
                    <Box p={2}>
                        <Grid container spacing={2} justifyContent="flex-end">
                            <Grid item xs={12}>
                                <Breadcrumbs fileSystemNodePath={state.selectedFileSystemNodePath} setSelectedFileSystemNodePath={(path, type) => dispatch(new setSelectedFileSystemNodePathAction(path, type))}/>
                            </Grid>
                            {
                                fileSystemNodeType == 'directory' &&
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} lg={4}>
                                            <FilterTextField filterText={ state.filterText } setFilterText={ (text) => dispatch(setFilterTextAction(text)) }/>
                                        </Grid>
                                        <Grid item xs={12} lg={8}>
                                            <TagField filterTags={state.filterTags} setFilterTags={ (tags) => dispatch(setFilterTagsAction(tags)) }/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                            <Uploader fileSystemNodePath={state.selectedFileSystemNodePath}>
                                <Grid item xs={12}>
                                    { (() => {
                                        if (fileSystemNodeType == 'directory') {
                                            return (
                                                <DirectoryContent
                                                    fileSystemNodePath={state.selectedFileSystemNodePath}
                                                    filterText={state.filterText}
                                                    filterTags={state.filterTags}
                                                    setSelectedFileSystemNodePath={(path, type) => dispatch(new setSelectedFileSystemNodePathAction(path, type))}
                                                    setTargetItemIndex={(targetItemIndex) => dispatch(new setDirectoryContentTargetItemIndexAction(targetItemIndex))}
                                                    targetItemIndex={state.directoryContentTargetItemIndexes.get(state.selectedFileSystemNodePath.join('/')) ?? 0}/>
                                            );
                                        } else if (isLoading && !fileSystemNodeType) {
                                            return <CenteredSpinner/>;
                                        }
                                        else if (!isLoading && !fileSystemNodeType) {
                                            return <MissingResourceAlert/>;
                                        } else {
                                            return <>
                                                <Box mb={2}>
                                                    <Media noMargin={true} type={fileSystemNodeType} url={fileSystemNodeDirectLinkUrl} previewUrl={fileSystemNodePreviewDirectLinkUrl} previewState={fileSystemNodePreviewState}/>
                                                </Box>
                                                <DownloadButton url={fileSystemNodeDirectLinkUrl}/>
                                            </>
                                        }
                                    })() }
                                </Grid>
                                <UploaderDashboard/>
                            </Uploader>
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
    return <></>;
}

export default FileExplorer;